import confetti from "canvas-confetti";

/**
 * AddVendTour brand palette confetti. Fires a 3-burst cannon (left / center /
 * right) for a satisfying "you just unlocked something" moment.
 *
 * Colors are pulled from the logo palette so the celebration reads as brand,
 * not stock. Total run time ≈ 900ms. Safe to call from any React event
 * handler — no cleanup needed, canvas-confetti creates + tears down its own
 * DOM node.
 *
 * Options:
 *   particleCount?: number  (default 90 per burst)
 *   spread?:        number  (default 70°)
 *   scalar?:        number  (default 1.0, size multiplier — bigger for
 *                            desktop bursts, smaller for inline chip taps)
 */
const AVT_COLORS = ["#2CC4D9", "#6B2FBA", "#F97316", "#EC4899", "#84CC16"];

export function celebrate({ particleCount = 90, spread = 70, scalar = 1.0 } = {}) {
  const shared = {
    particleCount,
    spread,
    startVelocity: 45,
    scalar,
    colors: AVT_COLORS,
    zIndex: 9999, // sit above every dialog / sonner toast
    disableForReducedMotion: true, // respect prefers-reduced-motion
    ticks: 200,
  };
  // Left-edge burst angled up-right
  confetti({ ...shared, angle: 60, origin: { x: 0.1, y: 0.6 } });
  // Center burst straight up
  confetti({ ...shared, angle: 90, origin: { x: 0.5, y: 0.55 } });
  // Right-edge burst angled up-left
  confetti({ ...shared, angle: 120, origin: { x: 0.9, y: 0.6 } });
}
